<template>
  <v-app  >
    <cabecera />
    <v-main style="background-color:#6D9886;" >
<cabecerabaja class=" hidden-md-only hidden-lg-only hidden-xl-only"  />

        <section id="main-cuerpo" v-bind:style="stylePagina" >
          <v-row justify="center" ref="cuerpo"  v-bind:style="styleMain">
              <v-col cols="12" md="10" lg="10">
         <center>       <v-carousel v-if="escogido" v-model="currentIndex"  ref="carousel" :continuous="false" cycle :hide-delimiters="true" :vertical="true" :show-arrows="false" :interval="interval">
                  <v-carousel-item   v-for="ins in inscritos" :key="ins.id" :index="ins.id">

                <p style="font-size: 20pt; ">    {{ ins.nombre }}
                </p> </v-carousel-item>

                </v-carousel>
           <div v-else>
             <v-row justify="center" align="center"><v-col cols="8">
             <v-img contain src="https://tunaydisenio.s3.sa-east-1.amazonaws.com/confetti.gif">
               <p style="font-size: 25pt; position: relative; top: 60%; font-family:'Futura Bk BT'; font-weight: bold;" >  {{nombreentero}} </p>
             </v-img></v-col></v-row>
             </div>
         </center> </v-col>
            <v-col cols="12" md="2" lg="2">
              <v-btn fab color="primary" x-large @click="girar">{{ labelbton }} </v-btn>
            </v-col>
          </v-row>

        </section>
        <v-overlay :value="overlay">
          <v-img
              src="@/assets/infinity.gif"

          />
        </v-overlay>
<piepagina />
    </v-main>
  </v-app>
</template>

<script>
import axios from "axios";
import moment from "moment";
import Cabecera from "@/components/general/cabecera";
import Cabecerabaja from "@/components/general/cabecerabaja";
import {mapGetters} from "vuex";
import Piepagina from "@/components/general/piepagina";

export default {
  name: "sorteo",
  components: {Piepagina, Cabecerabaja, Cabecera},
  data () {
    return {
      tagevento:'',
      alertnuevo: false,
      campoapmaterno: false,
      date: new Date().toISOString().substr(0, 10),
      menu1: false,
      emailRules: [
        v => !!v || 'E-mail es requerido',
        v => /.+@.+\..+/.test(v) || 'E-mail debe ser valido',
      ],
      inscritos:[],
      rest: false,
      overlay:false,
      currentIndex:0,
      hooperSettings: {
        itemsToShow: 1,
        centerMode: true,
        infiniteScroll: true,
        vertical: true,
        autoPlay:true,
        playSpeed: 10
      },
      campodireccion: false,
      campodistrito: false,
      campofecnac: false,
      campofoto: false,
      campoinvitado: false,
      campoizqder: false,
      camporeferido: false,
      camposexo: false,
      campotelefono: false,
      campofumador: false,
      campotipocarnet: false,
      campocondiciones:false,
      nombreentero:'',
      camporef1: false,
      camporef2:false,
      condiciones: '',
      escogido: true,
      labelbton:'Girar',
      labelNombre:'Nombre',
      labelApellidoPaterno:'Apellido Paterno',
      labelApellidoMaterno:'Apellido Materno',
      labelDNI:'Dni',
      labelDistrito: 'Distrito',
      labelTipoDocumento:'Tipo de Documento',
      labelFechaNacimiento: 'Fecha de Nacimiento',
      labelEmail:'Email',
      labelSexo:'Sexo',
      labelRef1:'',
      labelRef2:'',
      titulonegocio:'',
      logoexist: false,
      logoimg : '',
      interval:0,
      eventodisenio: {},
      stylePagina: {
        fontColor:'black',
        fontFamily: 'Futura Bk BT',
        color: '#000000',
        paddingTop:'30px'
      },
      styleComponent:{
        color:'#000000',
      },
      styleCabecera:{
        color:'#000000',
        backgroundColor:'#ffffff'
      },
ciudadId:0,
      ciudades:[],
      provinciaId:0,
      provincias:[],
      paisId:0,
      styleForm:{
        color:'#000000',
        backgroundColor:'#ffffff',
        marginTop:'0px !important'
      },
      styleMain:{

      },
      btnPag: {
        backgroundColor: 'blue',
        color:'white'
      },
      tag:'',
      autoplay:true,
      referido:'',
      fiesta:{},
      editedItem:{
        fechaNacimiento:null,
        apPaterno:'',
        apMaterno:'',
        dni:'',
        distrito:{},
        nombre:'',
        foto:'',
        email:'',
telefono:'',
direccion:'',
sexo:{},
tipoDocumento:{},
        ref1:'',
        ref2:'',
      }
    }
  },


  watch: {
    date () {
      this.editedItem.fechaNacimiento = this.formatDatee(this.date)
    }
  },
  mounted () {
    this.tag =  this.$route.params.tag;
    this.fiesta = this.$route.params.fiesta;
    this.dameInscritos();
  },
  methods: {
    formatDatee(value) {
      return moment(value).locale('es-pe').format("YYYY-MM-DD")
    },
    gotocero(){
      this.interval = 0
      let estos = this.inscritos[this.currentIndex]
      this.escogido = false
      this.nombreentero = estos.nombre
    },
    girar(){
      if(this.interval === 0){
        this.interval=100
        setInterval(this.gotocero,5000)
      }else{

        this.interval = 0
        this.escogido = true
      }
    },

    formatDateRe(value) {
      return moment(value).locale('es-pe').format("DD-MM-YYYY")
    },
    shuffle() {
    let currentIndex = this.inscritos.length,  randomIndex;

  // While there remain elements to shuffle.
    while (currentIndex != 0) {

    // Pick a remaining element.
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex--;

    // And swap it with the current element.
    [this.inscritos[currentIndex], this.inscritos[randomIndex]] = [
      this.inscritos[randomIndex], this.inscritos[currentIndex]];
      }

    },
    formatDate (date) {
      if (!date) return null;
      const [year, month, day] = date.split('-');
      return `${year}-${month}-${day}`;
    },
    parseDate (date) {
      if (!date) return null

      const [day,month, year] = date.split('/')
      return `${day.padStart(2, '0')}-${month.padStart(2, '0')}-${year}`
    },
    dameInscritos(){
      this.overlay = true
      axios
          .get('lista/fiesta/sortear/'+this.fiesta.id)
          .then(response => {
            this.inscritos = response.data;
            this.overlay = false
            this.shuffle();

          })
          .catch((error)  => {
            this.overlay = false
            this.alerterror = true
            this.texterror = error
            this.progr = false;
          });
    },

    damedisenio(){
      axios
          .get('disenio/evento/'+this.tagevento)
          .then(response => {
            this.eventodisenio = response.data;
            console.log(this.eventodisenio);
            this.dameInscritos()
            this.campoapmaterno= this.eventodisenio.campoapmaterno;
            this.labelApellidoMaterno = this.eventodisenio.labelApmaterno;
            this.labelApellidoPaterno = this.eventodisenio.labelAppaterno;
            this.campotelefono = this.eventodisenio.campotelefono;
            this.campoinvitado = this.eventodisenio.campoinvitado;
            this.camposexo = this.eventodisenio.camposexo;
            this.campodireccion = this.eventodisenio.campodireccion;
            this.campodistrito = this.eventodisenio.campodistrito;
            this.campofecnac  = this.eventodisenio.campofecnac;
            this.campofumador = this.eventodisenio.campofumador;
            this.logoexist = this.eventodisenio.logoCargado;
            this.logoimg = this.eventodisenio.logo;
            this.stylePagina.color = this.eventodisenio.colorText;
            this.btnPag.color = this.eventodisenio.colorTextBotn;
            this.btnPag.backgroundColor = this.eventodisenio.colorBgBoton;
            this.labelRef1 = this.eventodisenio.labelRef1;
            this.labelRef2 = this.eventodisenio.labelRef2;
            this.camporef1 = this.eventodisenio.camporef1;
            this.camporef2 = this.eventodisenio.camporef2;
            this.styleMain.backgroundSize = "cover";
            this.stylePagina.backgroundImage = "url('"+this.eventodisenio.backgroundImage+"')";

            this.styleCabecera.backgroundColor = this.eventodisenio.backCabeceraColor;
          })
          .catch((error)  => {
            console.log(error);
          });
    }
  },
  computed:{
    randomColor() {
      const r = () => Math.floor(256 * Math.random());
      return `rgb(${r()}, ${r()}, ${r()})`;
    },
    ...mapGetters({
      usuario: "usuario"
    })
  }
}
</script>
